import { Outlet } from 'react-router-dom';

import ThreadsHeader from './ThreadsHeader';

const Threads = () => (
  <div>
    <ThreadsHeader />
    <Outlet />
  </div>
);

export default Threads;
